var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpSignToNavigate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8561 16.5098L14.5361 5.18977C14.0261 4.39977 13.1661 3.92977 12.2261 3.92977C11.2861 3.92977 10.4261 4.39977 9.91614 5.18977L2.59614 16.5098C2.03614 17.3698 1.99614 18.4198 2.48614 19.3198C2.97614 20.2198 3.87614 20.7598 4.90614 20.7598H19.5561C20.5761 20.7598 21.4861 20.2198 21.9761 19.3198C22.4661 18.4198 22.4261 17.3698 21.8661 16.5098H21.8561Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSignToNavigate);
export default __webpack_public_path__ + "static/media/arrow-up-sign-to-navigate.01fbe7d896347207cf6db301529b99f7.svg";
export { ForwardRef as ReactComponent };